export const businessEmailCheck = async (email: string) => {
  try {
    const response = await fetch('/lpapi/form/EmailDomainCheck', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: email }),
    });

    const data = await response.json();

    if (data.isGeneric === '0') {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
